import React from 'react';
import { Feed, Image } from 'semantic-ui-react';

import { ForumLink } from '../../Links';

interface ForumProps {
  // isSchool?: boolean;
  alias: string;
  id: string;
  logo?: {
    url: string;
  };
  name: string;
}

const Forum = ({
  // isSchool,
  alias,
  id,
  logo,
  name,
}: ForumProps) => (
  <Feed.Event>
    {
      logo && (
        <Feed.Label>
          <Image src={logo.url} />
        </Feed.Label>
      )
    }
    <Feed.Content>
      <Feed.Summary>
        <ForumLink id={id}>
          <div>
            {name}
            {' '}
            (
            {alias}
            )
          </div>
        </ForumLink>
      </Feed.Summary>
    </Feed.Content>
  </Feed.Event>
);

export default ({ data }: { data: ForumProps[] }) => (
  data.length > 0 ? (
    <Feed size="large">
      {data.map((forum) => (
        <Forum
          alias={forum.alias}
          id={forum.id}
          key={forum.id}
          logo={forum.logo}
          name={forum.name}
        />
      ))}
    </Feed>
  ) : null
);
